/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import ColumnMultiSeriesgroup from '@fusioncharts/charts/src/dataset/groups/column-multiseries';
import { extend2 } from '@fusioncharts/core/src/lib';

/**
 * Group for drag column, area and line charts.
 */
class DragColumnMultiseriesGroup extends ColumnMultiSeriesgroup {
  /**
  * Function to get the jsonData from the datasets
  * @return {Object} data from the dataset
  */
  getJSONData () {
    var manager = this,
      datasets = manager.getChildren('dataset'),
      jsonData = [],
      dataset,
      datasetObj,
      rawDataset,
      i,
      len = datasets.length; // eslint-disable-line good-practices/no-single-usage-variable
    for (i = 0; i < len; i++) {
      dataset = datasets[i];
      rawDataset = extend2({}, manager.getFromEnv('dataSource').dataset[i]);
      // Here the actual data is deleted and modified data is fetched from each datasets
      delete rawDataset.data;
      datasetObj = dataset.getJSONData();
      jsonData.push(extend2(rawDataset, datasetObj));
    }
    return jsonData;
  }
}

export default DragColumnMultiseriesGroup;
